module.exports = __webpack_public_path__ + "img/app-lobby-menu.bad130c8.png";